const defaultAggProps = {
	siteBoundaryFactor: .95,
	avoidNorthFactor: 0,
	avoidNorthRange: 22.5,
	adjacencyFactor: .8,
	disableTBranches: true,
	maxWingLength: 100,
	maxPlotCount: 100,
	minWidth: 34.95,
	minArea: 34.95 * 50,
	maxLength: 100,
	allowLongitudinalSplit: true
};
export { defaultAggProps };

//# sourceMappingURL=index60.js.map